import type { FC } from 'react';

import HookFormErrors from '@app/components/HookFormErrors';

import type { AddressFormNamespaces } from '../Address.constants';
import { ADDRESS_FIELD_KEYS, AddressFormFields } from '../Address.constants';
import { AddressFields } from './AddressFields';
import { CompanyField } from './CompanyField';
import { CountryRegionField } from './CountryRegionField';
import { NameFields } from './NameFields';
import { PhoneField } from './PhoneField';
import { VatNumberField } from './VatNumberField';

const AddressForm: FC<{
  namespace: AddressFormNamespaces;
  countryCode?: string;
  hiddenFields?: string[];
  isVirtual?: boolean;
}> = ({ namespace, hiddenFields, isVirtual }) => {
  return (
    <div
      data-testid={`${namespace}-address-form`}
      css={{ position: 'relative' }}
    >
      <HookFormErrors fields={ADDRESS_FIELD_KEYS} namespace={namespace} />

      <NameFields namespace={namespace} />

      <AddressFields namespace={namespace} />

      <CountryRegionField namespace={namespace} isVirtual={isVirtual} />

      {!hiddenFields?.includes(AddressFormFields.Phone) && (
        <PhoneField namespace={namespace} />
      )}

      <CompanyField namespace={namespace} />

      {!hiddenFields?.includes(AddressFormFields.VatNumber) && (
        <VatNumberField namespace={namespace} />
      )}
    </div>
  );
};

export default AddressForm;
